export default __webpack_public_path__ + "static/media/Laura-Matt-testimonial.6c5d2280.webp";